import { render, staticRenderFns } from "./AdminMiscRoute.vue?vue&type=template&id=4b8cfd3e"
import script from "./AdminMiscRoute.vue?vue&type=script&lang=js"
export * from "./AdminMiscRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports